export enum VsFileResponeType {
    string,
    object
}
